import { FlightStore } from "@models/store.model";
import { createReducer, on } from "@ngrx/store";
import { setFlightFareRuleMapKey, setFlightFareRule } from "../actions/flight.action";

const initialState: FlightStore = {
    flightFareRuleMapKey: [],
    flightFareRules: {},
};

export const flightReducer = createReducer<FlightStore>(
    initialState,
    on(setFlightFareRuleMapKey, (state, { fareRules }) => {
        return {
            ...state,
            flightFareRuleMapKey: fareRules,
        };
    }),
    on(setFlightFareRule, (state, { fareRule }) => {
        return {
            ...state,
            flightFareRules: {
                ...state.flightFareRules,
                ...fareRule,
            },
        };
    }),
)